'use client'
import React, { useLayoutEffect } from 'react'
import { ExtractAtomValue, useAtom, useSetAtom } from 'jotai'

import { themeAtom } from '@/components/apps/Freeze'
import { ChatVisibleAtom } from '@/components/widget/Chat'
import { backgroundAtom, colorAtom, logoVisibleAtom, menuVisibleAtom } from '@/components/widget/Header'

type Props = {
	children: React.ReactNode
	headerTextColor?: ExtractAtomValue<typeof colorAtom>
	headerBackground?: ExtractAtomValue<typeof backgroundAtom>
	logoVisible?: ExtractAtomValue<typeof logoVisibleAtom>
	menuVisible?: ExtractAtomValue<typeof menuVisibleAtom>

	ChatVisible?: ExtractAtomValue<typeof ChatVisibleAtom>
	background?: ExtractAtomValue<typeof themeAtom>
}

const LayoutColorOption = ({
	headerTextColor,
	headerBackground,
	logoVisible,
	menuVisible,

	ChatVisible,
	children,
	background,
}: Props) => {
	const headerColorSet = useSetAtom(colorAtom)
	const headerBackgroundSet = useSetAtom(backgroundAtom)
	const logoVisibleSet = useSetAtom(logoVisibleAtom)
	const menuVisibleSet = useSetAtom(menuVisibleAtom)

	const ChatVisibleAtomSet = useSetAtom(ChatVisibleAtom)
	const backgroundAtomSet = useSetAtom(themeAtom)

	useLayoutEffect(() => {
		if (headerTextColor != null) headerColorSet(headerTextColor)
		if (menuVisible != null) menuVisibleSet(menuVisible)
		if (logoVisible != null) logoVisibleSet(logoVisible)
		if (headerBackground != null) headerBackgroundSet(headerBackground)

		if (ChatVisible != null) ChatVisibleAtomSet(ChatVisible)
		if (background != null) backgroundAtomSet(background)
	}, [headerTextColor, headerBackground, background, logoVisible, menuVisible, ChatVisible])
	return <>{children}</>
}

export default LayoutColorOption
